<script setup>
import {onMounted, ref} from "vue";
defineOptions({ name: 'BulkSendsView' })
import {useBulkSendStore} from "../../store/bulkSends.js";
import EmptyState from "../../components/global/EmptyState.vue";
import Pagination from "../../components/section/Pagination.vue";
import SectionHeader from "../../components/section/SectionHeader.vue";
import BulkSendRowItem from "../../components/bulkSends/BulkSendRowItem.vue";
import {useToastrStore} from "../../store/toastr.js";

const store = useBulkSendStore()
const toastrStore = useToastrStore()
const loading = ref(true)

const getBulkSends = async (page = 1) => {
    await store.getBulkSends({page, limit: 25})
}

onMounted(async () => {
    await getBulkSends()
    loading.value = false
})

const exportBulkSends = async (bulkSend) => {
    try {
        await store.exportBulkSends(bulkSend.uuid)
        toastrStore.show("Export in progress — you’ll get a notification when it’s ready to download")
    } catch (e) {
        console.log(e)
    }
}
</script>

<template>
    <main v-if="loading">
        <empty-state icon="speechbubble-double" heading="Loading bulk sends." content="Give it a sec, it's coming in a mo." />
    </main>

    <main v-else-if="store.bulk_sends?.data?.length">
        <section>
            <section-header heading="Bulk sends." />

            <div class="section-table">
                <bulk-send-row-item :bulk_send="b" v-for="b in store.bulk_sends.data" :key="b.uuid" @export="exportBulkSends" />
            </div>

            <div class="section-footer">
                <pagination :pagination="store.bulk_sends" @change-page="getBulkSends" />
              
            </div>
        </section>
    </main>

    <main v-else>
        <empty-state icon="speechbubble-double" heading="No bulk sends yet."
                     content="Filter the orders list, then use the bulk WhatsApp button to start one." />
    </main>
</template>
